// extracted by mini-css-extract-plugin
export default {"content":"kYj6QtcjcrrxC1nEN9Dv"};